<template>
    <li class="nav-item dropdown perfil">
        <el-popover
            class="nav-link"
            placement="bottom"
            :width="250"
            trigger="click"
        >
            <template #reference>
                <a click.prevent="" class="nav-link dropdown-toggle">
                    <em class="mdi mdi-account"></em>
                </a>
            </template>
            <div class="dw-user-box">
                <table class="infoBox">
                    <tr>
                        <td>
                            <div class="u-text">
                                <h4 class="nom">{{nom}}</h4>
                                <p v-if='email' class="text-muted email">{{email}}</p>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div>
                <a class="nav-link" @click="logout()"> 
                    <el-icon><SwitchButton /></el-icon> 
                    {{$t('Tancar sessió')}}
                </a>
            </div>
        </el-popover>
    </li>
</template>

<script>
    /**
     * Mostra informació associada a l'usuari autenticat.
     */
    export default {
        name: 'CustomPerfil',
        props: {
            // Nom de l'usuari
            nom: {
                type: String,
                required: true,
            },
            // Email de l'usuari
            email: {
                type: String,
                required: false,
            },
        },
        methods: {
            logout() {

                // Salta un error perque no hi ha adreça per fer logout
                this.$oidc.signOut()

                //Per si no funciona bé el logut anem a la home
                this.$router.push('/')
            }
        }
    }
</script>

<style scoped>
a.nav-link {
    color: #007bc0 !important;
    cursor: pointer;
}
</style>
